import type { ReactElement } from "react";
import type { MiniAppRoute } from "../../api/types.js";

interface NavIconProps {
  route: Exclude<MiniAppRoute, "manager" | "all_categories">;
  active?: boolean;
}

export function NavIcon({ route, active = false }: NavIconProps) {
  const stroke = active ? "currentColor" : "currentColor";
  const opacity = active ? 1 : 0.72;

  const paths: Record<Exclude<MiniAppRoute, "manager" | "all_categories">, ReactElement> = {
    home: (
      <path
        d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5Z"
        fill="none"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    ),
    catalog: (
      <>
        <rect x="4" y="4" width="7" height="7" rx="1.5" fill="none" stroke={stroke} strokeWidth="1.6" />
        <rect x="13" y="4" width="7" height="7" rx="1.5" fill="none" stroke={stroke} strokeWidth="1.6" />
        <rect x="4" y="13" width="7" height="7" rx="1.5" fill="none" stroke={stroke} strokeWidth="1.6" />
        <rect x="13" y="13" width="7" height="7" rx="1.5" fill="none" stroke={stroke} strokeWidth="1.6" />
      </>
    ),
    cart: (
      <>
        <path
          d="M6 6h15l-2 9H8L6 6Z"
          fill="none"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinejoin="round"
        />
        <path d="M6 6 5 3H2" fill="none" stroke={stroke} strokeWidth="1.6" strokeLinecap="round" />
        <circle cx="10" cy="19" r="1.4" fill={stroke} />
        <circle cx="18" cy="19" r="1.4" fill={stroke} />
      </>
    ),
    checkout: (
      <path
        d="M6 6h15l-2 9H8L6 6Z"
        fill="none"
        stroke={stroke}
        strokeWidth="1.6"
      />
    ),
    profile: (
      <>
        <circle cx="12" cy="8" r="3.5" fill="none" stroke={stroke} strokeWidth="1.6" />
        <path
          d="M5 20c1.8-3.5 4.3-5 7-5s5.2 1.5 7 5"
          fill="none"
          stroke={stroke}
          strokeWidth="1.6"
          strokeLinecap="round"
        />
      </>
    ),
  };

  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="shrink-0"
      style={{ opacity }}
    >
      {paths[route]}
    </svg>
  );
}
